import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { Sparkles, Trash2 } from 'lucide-react';
import {
  getVariableGroup,
  templateVariableDisplayNames,
} from '@/components/richText/templateVariableDisplayNames.ts';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover.tsx';
import { useVariable } from '../contexts/VariablesContext.tsx';
import RichTextPreview from '../RichTextPreview.tsx';

const getDisplayLabel = (variable: string): string => {
  const group = getVariableGroup(variable);
  const groupName = group ? templateVariableDisplayNames[group] : undefined;
  const variableName = templateVariableDisplayNames[variable];

  if (groupName && variableName && group !== variable) {
    return `${groupName}.${variableName}`;
  }
  return variableName ?? variable;
};

const TemplateVariableBlockChip = ({ node, deleteNode }: NodeViewProps) => {
  const variableKey = node.attrs.variable as string;
  const variable = useVariable(variableKey);
  const previewHtml = variable?.exampleValue ?? '';
  const label = getDisplayLabel(variableKey);

  // `clear-both`: drop this dynamic-section chip below a floated/wrapped image
  // instead of letting its accent background bleed under the float.
  return (
    <NodeViewWrapper as="div" className="clear-both my-2">
      <Popover>
        <PopoverTrigger asChild>
          <div className="cursor-pointer select-none rounded-md border border-dashed border-accent-400 bg-accent-100 p-2">
            <div className="mb-1 flex items-center gap-1 text-xs font-semibold text-neutral-600">
              <Sparkles size={12} />
              <span>Dynamiczna treść: {label}</span>
            </div>
            {previewHtml ? (
              <RichTextPreview
                html={previewHtml}
                className="pointer-events-none"
              />
            ) : (
              <div className="text-sm italic text-neutral-500">
                Brak podglądu dla "{variableKey}"
              </div>
            )}
          </div>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto min-w-[200px] p-2">
          <div className="space-y-2">
            <div>
              <div className="text-sm font-semibold text-neutral-900">
                {label}
              </div>
              <div className="mt-1 text-xs text-neutral-600">
                Dynamiczna sekcja (np. tabela)
              </div>
            </div>
            <div className="border-t border-neutral-100 pt-1">
              <button
                type="button"
                onClick={() => deleteNode()}
                className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-error-300 hover:bg-error-100"
              >
                <Trash2 size={14} /> Usuń zmienną
              </button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </NodeViewWrapper>
  );
};

export default TemplateVariableBlockChip;
